module.exports = __webpack_public_path__ + "img/hongbao_1.4415ba4e.png";